import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react'
import { cn } from '@bem-react/classname'

import './FormGroup.scss'

export const cnFormGroup = cn('FormGroup')

export type AlignmentVerticalType = 'center' | 'bottom' | 'top'
export type AlignmentHorizontalType = 'left' | 'center' | 'right'
export type MarginType = 'none' | 'small' | 'medium' | 'large' | 'xlarge'
export interface FormGroupSchema
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: ReactNode
  title?: string
  isBordered?: boolean
  isGroup?: boolean
  verticalAlignment?: AlignmentVerticalType
  horizontalAlignment?: AlignmentHorizontalType
  fakeLabel?: boolean
  isLight?: boolean
  // isSmall?: boolean
  isTitleRelative?: boolean
  margin?: MarginType
}

export const FormGroup: FC<FormGroupSchema> = ({
  children,
  className,
  title,
  isBordered,
  isGroup,
  verticalAlignment,
  horizontalAlignment,
  fakeLabel,
  isLight,
  // isSmall,
  isTitleRelative,
  margin = 'large',
}): JSX.Element => {
  return (
    <div
      className={cnFormGroup(
        {
          light: isLight,
          // small: isSmall && isBordered,
          border: isBordered,
          group: isGroup,
          aic: verticalAlignment === 'center',
          ait: verticalAlignment === 'top',
          aib: verticalAlignment === 'bottom',
          jcc: horizontalAlignment === 'center',
          jcl: horizontalAlignment === 'left',
          jcr: horizontalAlignment === 'right',
          none: margin === 'none',
          small: margin === 'small',
          medium: margin === 'medium',
          large: margin === 'large',
          xlarge: margin === 'xlarge',
        },
        [className],
      )}
    >
      {fakeLabel && <div className={cnFormGroup('fake')}></div>}

      {title && isBordered && (
        <div className={cnFormGroup('title', { relative: isTitleRelative })}>
          {title}
        </div>
      )}
      {children}
    </div>
  )
}
